import i18next from "i18next";

export default function localize(key: string) {
  return i18next.t(key as string);
}
